<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">设备限免</span>
      </div>
      <div class="right">
        <Button
          type="primary"
          @click="
            openModal({
              color: 0,
              type: 0,
              is_coupon: 1,
              user_type: 0,
              exceed: 0,
              rule: [{ days: 1, sheet: 1 }],
            })
          "
          >新增设备限免</Button
        >
      </div>
    </div>
    <div>
      <Table
        :columns="columns"
        :data="data"
        :loading="tableLoading"
        @on-expand="getMachines"
      />
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
    <Modal v-model="visible" title="设备限免" width="750">
      <Form ref="formInline" :model="current" :rules="rule" :label-width="100" inline>
        <FormItem prop="agent_id" label="合作伙伴:" v-if="!user.tp" required>
          <Select v-model="current.agent_id" style="width: 220px" filterable>
            <Option v-for="item in agentList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="name" label="活动名称:">
          <Input v-model="current.name" style="width: 220px" placeholder="活动名称" />
        </FormItem>

        <FormItem prop="color" label="禁用颜色:">
          <Select v-model="current.color" style="width: 220px">
            <Option
              v-for="item in Object.keys(color)"
              :value="parseInt(item)"
              :key="item"
              >{{ color[parseInt(item)] }}</Option
            >
          </Select>
          <p class="txt-tips">选择的颜色订单不参与限免活动</p>
        </FormItem>
        <FormItem prop="type" label="禁用类型:">
          <Select v-model="current.type" style="width: 220px">
            <Option
              v-for="item in Object.keys(type)"
              :value="parseInt(item)"
              :key="item"
              >{{ type[parseInt(item)] }}</Option
            >
          </Select>
          <p class="txt-tips">选择的作业类型订单不参与限免活动</p>
        </FormItem>
        <FormItem prop="is_coupon" label="优惠券限制:">
          <RadioGroup v-model="current.is_coupon">
            <Radio :label="1">允许</Radio>
            <Radio :label="0">不允许</Radio>
          </RadioGroup>
          <p class="txt-tips">优惠券与限免活动是否允许同时生效</p>
        </FormItem>

        <FormItem prop="user_type" label="会员类型:">
          <Select v-model="current.user_type" style="width: 220px">
            <Option
              v-for="item in Object.keys(user_type)"
              :value="parseInt(item)"
              :key="item"
              >{{ user_type[parseInt(item)] }}</Option
            >
          </Select>
          <p class="txt-tips">选择的会员类型才参与限免活动</p>
        </FormItem>
        <FormItem prop="exceed" label="超限免后:">
          <RadioGroup v-model="current.exceed">
            <Radio :label="0">付费输出</Radio>
            <Radio :label="1">禁止使用</Radio>
          </RadioGroup>
          <p class="txt-tips">如果设备关联计费方案为免费使用，此项只能勾选“禁止使用”</p>
        </FormItem>

        <FormItem label="使用规则:" required>
          <Button type="primary" size="small" @click="addRule">添加规则</Button>
          <p class="txt-tips">
            每个限免活动可同时设置3个时间周期，如每个会员每1天免10页、每7天免50页、每30天免100页（比如连续5天各使用了10页，第6和7的天就不能享受限免了，直到第8天才能继续享受30天的限免条件）
          </p>
        </FormItem>
        <div class="rule-item" v-for="(item, index) in current.rule" :key="index">
          <FormItem label="时间周期:" required>
            <InputNumber
              style="width: 120px"
              v-model="item.days"
              :min="1"
              :max="30"
              placeholder="单位：天"
            />
          </FormItem>
          <FormItem label="限免张数:" required>
            <InputNumber style="width: 120px" v-model="item.sheet" :min="1" :max="3000" />
          </FormItem>
          <Button
            type="primary"
            icon="md-close"
            shape="circle"
            v-if="index"
            @click="deleteUse(index)"
          ></Button>
        </div>
      </Form>
      <!-- <Alert type="warning" style="text-align: center"
        >使用规则：限定周期内只能参与一次</Alert
      > -->
      <div slot="footer">
        <Button size="large" @click="visible = false">取消</Button>
        <Button type="primary" size="large" @click="modalOk" :loading="modalLoading"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal v-model="bind_visible" width="300" :title="`限免绑定 - ${bind_data.name}`">
      <Input
        autofocus
        search
        ref="search"
        enter-button="搜索"
        v-model="bind_search"
        @on-search="getMachine"
        style="width: 268px"
        placeholder="输入完整设备序列号"
      />
      <Spin v-if="bind_spin" fix></Spin>
      <Alert
        v-if="bind_machine.id"
        style="margin-top: 10px; padding-right: 16px"
        :type="bind_machine.machine_activity_id ? 'warning' : 'success'"
      >
        <div class="alert-content">
          <span v-if="!bind_machine.machine_activity_id"
            >是否将此活动绑定该在此设备上?
          </span>
          <span v-if="bind_machine.machine_activity_id">设备已绑定活动,是否覆盖? </span>
          <Button type="primary" size="small" @click="bindData">确定</Button>
        </div>
      </Alert>
      <div slot="footer" style="padding: 0; border: none"></div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import expand from "./expand.vue";
export default {
  components: { expand },
  data() {
    this.color = {
      0: "不限",
      1: "黑白",
      2: "彩色",
    };
    this.type = {
      0: "不限",
      1: "打印",
      2: "复印",
      3: "扫描",
      5: "相片冲印",
      6: "身份证复印",
    };

    return {
      user_type: {
        0: "不限",
        1: "普通会员",
        2: "企业会员",
      },
      exceed: {
        0: "付费输出",
        1: "禁止使用",
      },
      bind_visible: false,
      bind_spin: false,
      bind_data: {},
      bind_machine: {},
      bind_search: "",
      data: [],
      page: {
        l: 10,
        p: 0,
      },
      total: 0,
      columns: [
        {
          type: "expand",
          width: 100,
          render: (h, data) => {
            return h(
              expand,
              {
                props: {
                  row: data.row,
                },
              },
              ""
            );
          },
        },
        { title: "编号", key: "id" },
        { title: "活动名称", key: "name" },
        // { title: "限免张数", key: "sheet" },
        // { title: "时间间隔", key: "days" },
        { title: "颜色限制", key: "color" },
        { title: "类型限制", key: "type" },
        { title: "优惠券限制", key: "is_coupon" },
        {
          title: "操作",
          width: 180,
          key: "operate",
          render: (h, data) => {
            return h("div", { style: { display: "flex" } }, [
              h(
                "Button",
                {
                  props: { size: "small", type: data.row.is_del ? "success" : "error" },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `是否${data.row.is_del ? "恢复" : "删除"}`,
                        content: `${
                          data.row.is_del ? "恢复" : "删除"
                        }设备限免活动,将解绑所有绑定此活动的设备`,
                        onOk: () => {
                          this.delActivity(data.row.id, data.row.is_del);
                        },
                      });
                    },
                  },
                },
                data.row.is_del ? "恢复" : "删除"
              ),
              h(
                "Button",
                {
                  props: { size: "small", type: "warning" },
                  style: { marginLeft: "5px" },
                  on: {
                    click: () => {
                      let params = JSON.parse(JSON.stringify(data.row));
                      params.rule = JSON.parse(params.rule);
                      this.openModal(params);
                    },
                  },
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: { size: "small", type: "info" },
                  style: {
                    marginLeft: "5px",
                    display: data.row.is_del ? "none" : "block",
                  },
                  on: {
                    click: () => {
                      this.openBind(data.row);
                    },
                  },
                },
                "绑定"
              ),
            ]);
          },
        },
      ],
      modalLoading: false,
      tableLoading: false,
      visible: false,
      current: {},
      rule: {
        name: [{ required: true, message: "名称必填" }],
        // ruleDays: [{ required: true, message: "规则周期必填" }],
        // ruleSheet: [{ required: true, message: "限免数量必填" }],
        /* sheet: [{ validator: (rule, value, callback)=>{
            if(parseInt(value) == value && parseInt(value) > 0){
              callback()
            }else{
              callback(new Error('请输入大于零正整数'))
            }
          }, required: true, trigger: 'blur'}],
          days: [{ validator: (rule, value, callback)=>{
            if(parseInt(value) == value && parseInt(value) > 0){
              callback()
            }else{
              callback(new Error('请输入大于零正整数'))
            }
          }, required: true, trigger: 'blur'}], */
      },
      agentList: [],
    };
  },
  methods: {
    getMachines(data, status) {},
    bindData() {
      this.bindMachine({
        id: this.bind_machine.id,
        machine_activity_id: this.bind_data.id,
      }).then((res) => {
        if (res) {
          this.$Message.success("绑定成功");
          this.bind_machine = {};
          this.bind_search = "";
          this.$refs.search.focus();
        }
      });
    },
    getMachine(value) {
      if (value) {
        this.bind_spin = true;
        this.machineInfo({ sn: value }).then((res) => {
          this.bind_spin = false;
          if (res.id) {
            this.bind_machine = res;
          } else {
            this.$Message.warning("未找到设备");
          }
        });
      }
    },
    openBind(data) {
      this.bind_visible = true;
      this.bind_data = data;
    },
    delActivity(id, is_del) {
      this.saveMachineActivity({
        data: { id: id, is_del: is_del ? 0 : 1 },
        unBind: true,
      }).then((res) => {
        this.data.map((item) => {
          if (item.id === id) {
            item.is_del = is_del ? 0 : 1;
          }
        });
      });
    },
    modalOk() {
      let data = JSON.parse(JSON.stringify(this.current));
      if (!data.rule || !data.rule.length) {
        this.$Message.error("请创建使用规则");
        return;
      }
      console.log("data", data,this.user.tp);
      if(!this.user.tp && !data.agent_id){
        this.$Message.error("请选择合作伙伴");
        return;
      }else{
        data.agent_id = this.user.id;
      }
      delete data.agent_name;
      let errs = [],
        maps = {};
      data.rule.forEach((element, index) => {
        if (maps[element.days]) {
          console.log("index", element);
          errs.push(`使用规则${index + 1}周期重复`);
        } else {
          maps[element.days] = true;
        }
      });
      if (errs.length) {
        this.$Message.error(errs[0]);
        return;
      }
      errs = [];
      maps = {};
      data.rule.forEach((element, index) => {
        console.log("index", index);
        if (maps[element.sheet]) {
          errs.push(`使用规则${index + 1}限免张数重复`);
        } else {
          maps[element.sheet] = true;
        }
      });
      if (errs.length) {
        this.$Message.error(errs[0]);
        return;
      }

      this.$refs.formInline.validate((valid) => {
        if (valid) {
          delete data._index;
          delete data._rowKey;
          data.rule = JSON.stringify(data.rule);
          this.saveMachineActivity({ data: data }).then((res) => {
            this.getData();
            this.visible = false;
          });
        }
      });
    },
    getData() {
      this.tableLoading = true;
      this.getMachineActivity(this.page).then((res) => {
        this.data = res.data;
        this.total = res.total;
        this.tableLoading = false;
      });
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    openModal(data) {
      this.$refs.formInline.resetFields();
      this.visible = true;
      this.current = data;
    },
    addRule() {
      if (this.current.rule.length >= 3) {
        this.$Message.error("最多只能创建3条使用规则");
        return;
      }
      this.current.rule.push({
        days: 1,
        sheet: 1,
      });
    },
    deleteUse(index) {
      this.current.rule.splice(index, 1);
    },
    agentAccess() {
      return hasOneOf(["0"], this.access);
    },

    ...mapActions([
      "getMachineActivity",
      "saveMachineActivity",
      "machineInfo",
      "bindMachine",
      "getAgentList",
    ]),
  },
  mounted() {
    this.getData();
    if (!this.user.tp) {
      this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
        this.agentList = res.data;
      });
      this.columns.splice(2, 0, {
        title: "合作伙伴",
        key: "agent_name",
        render: (h, data) => {
          return h("p", {}, data.row.agent_name || "-");
        },
      });
    }
  },
  computed: mapGetters({
    user: "agent",
    access: "access",
  }),
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
